module.exports = __webpack_public_path__ + "static/media/daniel_ogura.673c669f.png";